/*
 * RecColorBlocks.jsx
 * Created by Destin Frasier on 05/02/18
 */

import React from 'react';

export default class RecColorBlocks extends React.Component {
    render() {
        return (
            <ul className="rec-primary-color-blocks">
                <li />
                <li />
                <li />
                <li />
                <li />
            </ul>
        );
    }
}
